<template>
  <div class="declareBox">
    <div class="title"></div>
    <div class="content">
      <a-table
        :loading="outsideAllListLoading"
        :data-source="outsideAllListData"
        :rowKey="(outsideAllListData) => outsideAllListData.id"
        :scroll="{ x: 1500 }"
      >
        <a-table-column :ellipsis="true" title="服务类型" dataIndex="serviceType">
        </a-table-column>
        <a-table-column :ellipsis="true" title="机构名称" dataIndex="agentName">
        </a-table-column>
        <a-table-column :ellipsis="true" title="内容链接" dataIndex="contentUrl">
          <template slot-scope="contentUrl, outsideAllListData">
            <a
              class="btnCopyLink"
              @click="btnCopyLink"
              :data-clipboard-text="outsideAllListData.contentUrl"
              >复制链接</a
            >
          </template>
        </a-table-column>
        <a-table-column :width="150" fixed="right" title="设置" dataIndex="operation">
          <template slot-scope="id, outsideAllListData">
            <span>
              <a @click="() => btnEdit(outsideAllListData.id)">编辑</a>
              <a-popconfirm
                title="确定删除?"
                ok-text="确定"
                cancel-text="取消"
                @confirm="btnDelect(fundAllListData.id)"
              >
              </a-popconfirm>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
      :title="modalName"
      v-model="visibleAdd"
      :confirm-loading="confirmLoading"
      @ok="AddhandleOk"
    >
      <a-form
        :form="modelForm"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
        @submit="handleSubmit"
      >
        <a-form-item label="机构名称">
          <a-input
            placeholder="请输入课程名称"
            v-decorator="[
              'agentName',
              {
                rules: [{ required: true, message: '请输入课程名称' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="内容链接">
          <a-input
            type="textarea"
            placeholder="请输入课程名称"
            v-decorator="[
              'contentUrl',
              {
                rules: [{ required: true, message: '请输入课程名称' }],
              },
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import ClipboardJS from "clipboard";
export default {
  data() {
    return {
      outsideAllListLoading: true,
      outsideAllListData: [],
      pageSize: 10,
      current: 1,
      total: 0,
      confirmLoading: false,
      modelForm: this.$form.createForm(this, {
        name: "modelForm",
      }),
      modalName: "编辑课程",
      courseTypeSe: [
        {
          id: 1,
          name: "特色",
        },
        {
          id: 2,
          name: "实力",
        },
      ],
      courseAdvantageSe: [
        {
          id: 1,
          name: "特色",
        },
        {
          id: 2,
          name: "实力",
        },
      ],
      courseTargetSe: [
        {
          id: 1,
          name: "特色",
        },
        {
          id: 2,
          name: "实力",
        },
      ],
      visibleAdd: false,
      editId: "",
    };
  },
  methods: {
    //分页
    currentChange(val) {
      console.log(val);
      this.current = val;
      this.getCourseData();
    },
    getOutsideData() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.current,
        courseName: "",
        campus: "",
      };
      this.$http(this.$api.outsideData, data).then((r) => {
        console.log(r);
        this.outsideAllListLoading = false;
        this.outsideAllListData = r.data;
        this.total = r.data.total;
      });
    },
    //删除这条记录
    btnDelect(id) {
      let data = {
        id,
      };
      this.outsideAllListLoading = true;
      this.$http(this.$api.DELECTCOURSE, data).then((r) => {
        console.log(r);
        this.$notification["success"]({
          message: "删除成功",
          description: "课程删除成功",
        });
        this.getCourseData();
      });
    },
    //编辑这条记录
    btnEdit(id) {
      this.editId = id;
      this.visibleAdd = true;
      let flagData = this.outsideAllListData.find((Element) => {
        return Element.id == id;
      });
      console.log(flagData);
      this.$nextTick(() => {
        console.log(flagData.courseAdvantage);
        this.modelForm.setFieldsValue({
          contentUrl: flagData.contentUrl,
          agentName: flagData.agentName,
        });
      });
    },
    AddhandleOk() {
      this.handleSubmit();
    },
    handleSubmit() {
      this.confirmLoading = true;
      this.modelForm.validateFields((err, data) => {
        if (!err) {
          data.id = this.editId;
          console.log("Received values of form: ", data);
          this.$http(this.$api.EDITOUSIDEDATA, data).then((r) => {
            console.log(r);
            this.confirmLoading = false;
            this.visibleAdd = false;
            this.getOutsideData();
            this.$notification["success"]({
              message: "修改服务",
              description: "服务编辑成功",
            });
          });
        }
      });
    },
    //复制链接
    btnCopyLink() {
      var clipboard = new ClipboardJS(".btnCopyLink");
      let that = this;
      clipboard.on("success", function () {
        that.$message.success("地址复制成功");
      });

      clipboard.on("error", function (e) {
        console.log(e);
      });
    },
  },
  created() {
    this.getOutsideData();
  },
};
</script>
<style scoped lang="less">
.declareBox {
  width: 100%;
  height: 100%;
  padding: 0 40px;
  box-sizing: border-box;

  .title {
    text-align: center;
    height: 50px;
    font-size: 15px;
    line-height: 50px;
    width: 100%;
    font-weight: bold;
  }

  /deep/ .ant-table-tbody {
    .border {
      position: relative;
      top: -0.06em;
      display: inline-block;
      width: 1px;
      height: 0.9em;
      margin: 0 8px;
      vertical-align: middle;
      background-color: #e8e8e8;
    }
  }
}
</style>
